import { Inject, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { HttpService } from 'modules/shared/services/http.service';
import { ToastrService } from 'ngx-toastr';
import { PlayerDetailResponse } from 'model/shared/backend-api-response/player-detail-response';

declare var gigya: any;
@Injectable({
  providedIn: 'root',
})
export class CmsService {
  //initData
  tenantId;
  propertyId;
  idleTime;
  warningTime;
  casinoTimeoutRequired;
  backendDomainName;
  APIContext;
  servername_loyalty;
  serviceHeaders;
  propertyname_loyalty;
  casinoToken_property_name;
  casinoService;
  casinoLoginIdealTime: number = 0;
  casinoLoginWarningTime: number = 0;
  isPlayerLogin = new BehaviorSubject<boolean>(false);
  isReloginRequired = new BehaviorSubject<boolean>(false);
  casinoPlayers: Array<any> = [];
  isCasinoTimeoutRequired: boolean = false;
  cloudDomain: string;
  casinoNumber: string;
  casinoPlayerDetails: any;
  modalOpened: boolean = false;
  counter;
  dialogref;
  isCasinoLogin: boolean = false;
  thirdPartyGigyaLogin: boolean = false;
  isGigyaEnabled: boolean;
  public isCasinoUserLoggedIn = false;
  public primaryPlayerLoyaltyToken = '';
  public secondaryPlayerLoyaltyToken = '';
  public primaryCasinoPlayerTokenInterval: any;
  public secondaryCasinoPlayerTokenInterval: any;

  constructor(
    private httpService: HttpService,
    // private trackIdle: TrackidleService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.thirdPartyGigyaLogin = this.isGigyaEnabled;
    this.isPlayerLogin.subscribe((result) => {
      this.isCasinoLogin = result;
      this.isCasinoUserLoggedIn = result;
      if (result) {
        // this.trackIdle.start('casino');
      }
    });
  }

  private get toastService() {
    return this.injector.get(ToastrService);
  }

  // private get onecartInit() {
  //   return this.injector.get(OnecartAppInitializerService);
  // }

  loyaltyPlayerDetails(data) {
    this.casinoPlayerDetails = data;
    this.isPlayerLogin.next(true);
  }

  validateCasinoLogin(login) {
    login.pin = window.btoa(login.pin);
    let url =
      this.cloudDomain +
      '/' +
      this.casinoService +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.APIContext + '/') +
      'propertyName/' +
      this.casinoToken_property_name +
      '/validateCasino?appName=wbe';
    return this.httpService.put(url, login, this.serviceHeaders);
  }

  secondaryCasinoLogin(login) {
    login.pin = window.btoa(login.pin);
    let url =
      this.cloudDomain +
      '/' +
      this.casinoService +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.APIContext + '/') +
      'propertyName/' +
      this.casinoToken_property_name +
      '/validateCasino?appName=wbe';
    return this.httpService.put(url, login, this.serviceHeaders);
  }

  getCasinoPlayerDetails(casinoNo, gigyaFlow) {
    if (!gigyaFlow) {
      let header;
      let serviceHeaders = {
        loyaltyToken: this.primaryPlayerLoyaltyToken,
      };
      header = {
        headers: serviceHeaders,
      };
      let url1 =
        this.cloudDomain +
        '/' +
        this.servername_loyalty +
        '/tenants/' +
        this.tenantId +
        ('/context/' + this.APIContext + '/') +
        'propertyName/' +
        this.propertyname_loyalty +
        '/loyaltyProgram/casino/loyaltyId/' +
        casinoNo +
        '?appName=wbe';
      return this.httpService.get(url1, header);
    } else {
      let url2 =
        this.cloudDomain +
        '/' +
        this.servername_loyalty +
        '/tenants/' +
        this.tenantId +
        ('/propertyId/' + this.propertyId) +
        '/playerId/' +
        casinoNo;

      console.log(url2);

      let responseToBeSent = {
        Success: true,
        ErrorMessage: '',
        addressLine1: '',
        addressLine2: '',
        cityName: '',
        countryCode: '',
        emailAddress: '',
        title: '',
        firstName: '',
        lastName: '',
        mobilePhoneNumber: '',
        phoneNumber: '',
        postalCode: '',
        rank: {
          isRankActive: false,
          lmsRankDescription: 'Rank',
          externalValue: '',
          lmsRank: '',
          lmsRankColor: ' ',
        },
        tier: {
          isTierActive: false,
          lmsTierDescription: 'Tier',
          externalValue: '',
          lmsTier: '',
          lmsTierColor: ' ',
        },
        gender: '',
        dob: '',
        state: '',
        vip: '',
      };

      return this.httpService.get(url2, this.serviceHeaders).pipe(
        map((data: PlayerDetailResponse) => {
          console.log(data);
          if (data['success']) {
            responseToBeSent.addressLine1 = data?.playerDetail?.mailing_street ? data?.playerDetail?.mailing_street : '';
            responseToBeSent.cityName = data?.playerDetail?.mailing_city ? data?.playerDetail?.mailing_city : '';
            responseToBeSent.countryCode = data?.playerDetail?.mailing_country ? data?.playerDetail?.mailing_country : '';
            responseToBeSent.firstName = data?.playerDetail?.firstName ? data?.playerDetail?.firstName : '';
            responseToBeSent.lastName = data?.playerDetail?.lastName ? data?.playerDetail?.lastName : '';
            responseToBeSent.mobilePhoneNumber = data?.playerDetail?.MobilePhone || data?.playerDetail?.phone || '';
            responseToBeSent.phoneNumber = data?.playerDetail?.phone || data?.playerDetail?.MobilePhone || '';
            responseToBeSent.state = data?.playerDetail?.mailing_state ? data?.playerDetail?.mailing_state : '';
            responseToBeSent.tier.isTierActive = data?.playerDetail?.tier ? true : false;
            responseToBeSent.tier.lmsTier = data?.playerDetail?.tier ? data?.playerDetail?.tier : '';
            responseToBeSent.emailAddress = data?.playerDetail?.emailAddress ? data?.playerDetail?.emailAddress : '';
            responseToBeSent.postalCode = data?.playerDetail?.mailing_zip ? data?.playerDetail?.mailing_zip : '';
          } else {
            responseToBeSent.Success = false;
            responseToBeSent.ErrorMessage = data?.errorMessage;
          }
          return responseToBeSent;
        })
      );
    }
  }

  getSecondaryCasinoPlayerDetails(casinoNo) {
    let header;
    let serviceHeaders = {
      loyaltyToken: this.secondaryPlayerLoyaltyToken,
    };
    header = {
      headers: serviceHeaders,
    };
    let url;
    url =
      this.cloudDomain +
      '/' +
      this.servername_loyalty +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.APIContext + '/') +
      'propertyName/' +
      this.propertyname_loyalty +
      '/loyaltyProgram/casino/loyaltyId/' +
      casinoNo +
      '?appName=wbe';
    return this.httpService.get(url, header);
  }

  logoutCasino(errorInToken?) {
    if (errorInToken) {
      this.toastService.success('You are logged out. Kindly login to continue.');
    }

    this.isPlayerLogin.next(false);
    this.casinoPlayerDetails = {};
    this.modalOpened = false;
    //   localStorage.removeItem(`${this.pmsInit.tenantId}-${this.pmsInit.propertyId}-casinoNumber`);
  }

  setValue(
    tenantId,
    propertyId,
    idleTime,
    warningTime,
    casinoTimeoutRequired,
    backendDomainName,
    APIContext,
    servername_loyalty,
    serviceHeaders,
    propertyname_loyalty,
    casinoToken_property_name,
    casinoService,
    isPlayerLogin,
    casinoNumber,
    casinoPlayerDetails,
    secondaryCasinoNumber?,
    secondaryCasinoDetails?
  ) {
    this.casinoLoginIdealTime = idleTime || 30;
    this.casinoLoginWarningTime = warningTime || 30;
    this.isCasinoTimeoutRequired = casinoTimeoutRequired;
    this.cloudDomain = backendDomainName;
    this.tenantId = tenantId;
    this.propertyId = propertyId;
    this.APIContext = APIContext;
    this.servername_loyalty = servername_loyalty;
    this.serviceHeaders = serviceHeaders;
    this.propertyname_loyalty = propertyname_loyalty;
    this.casinoToken_property_name = casinoToken_property_name;
    this.casinoService = casinoService;
    this.casinoNumber = casinoNumber;
    this.casinoPlayerDetails = casinoPlayerDetails;
    this.isPlayerLogin.next(isPlayerLogin);
    this.casinoPlayers = [];
    if (casinoPlayerDetails)
      this.casinoPlayers.push({
        ...casinoPlayerDetails,
        casinoNumber: casinoNumber,
        isPrimary: true,
      });
    if (secondaryCasinoDetails && secondaryCasinoNumber)
      this.casinoPlayers.push({
        ...secondaryCasinoDetails,
        casinoNumber: secondaryCasinoNumber,
        isPrimary: false,
      });
  }

  updateServiceHeader(serviceHeaders) {
    this.serviceHeaders = serviceHeaders;
  }
}
